export default __webpack_public_path__ + "static/media/app-version-white.3ba00f3e.svg";